<template>
    <div id="document-details-page" class="container">
    <div>
        <a-modal v-if="hasFavoriteListOption" v-model="visible" title="Lista de favoritos" @ok="handleOk" okText="Favoritar" cancelText="Cancelar">
                <h6>Favoritar: {{this.modal_name_document}}</h6>
                <div  v-for="(item, index) in favoriteListOption"
                    :key="index" :class="`${modal_id_favorite == item.id || checkFavoriteExists(item.id) ? 'bg-gray' : ''}`"
                    @click="selectFavoriteId(item.id)"
                >
                    <p  >
                        {{item.name}}
                    </p>
                </div>

            </a-modal>
    </div>
    <div class="m-3 pt-3" >
        <a-breadcrumb separator=">">
            <a-breadcrumb-item href="/home">
                <router-link
                    :to="`/`"
                >
                    Home
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-if="levels_id !== 0" v-bind:href="`/levels/${this.levels_id}/${encodeUrl(levels_name)}`">
                <router-link
                    :to="`/levels/${this.levels_id}/${encodeUrl(levels_name)}`"
                >
                    {{this.levels_name}}
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-for="(father, index) in levels_fathers" 
                :key="index"  v-bind:href="`/itens/${father.id}/${encodeUrl(father.name)}`">
                <router-link
                    :to="`/itens/${father.id}/${encodeUrl(father.name)}`"
                >
                    {{father.name}}
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item href="#">
                <strong>
                    {{this.titleDefault || 'Sem título'}}
                </strong>
            </a-breadcrumb-item>
        </a-breadcrumb>
    </div>
    <hr class=" mb-5" />

    <div class="mt-5" v-if="!showError" :title="titleDefault">
         <dd-request-new-permission
                :document-id="id"
                :document-title="titleDefault"
                class="mb-6"
                v-if="!isAdmin"
            ></dd-request-new-permission>

        <div class="fab-card-titulo">
            <div>
                <a-icon
                    class="mt-3 mr-3"
                    v-if="documentType == 'mp3'"
                    style="fontSize:20px;color:green;"
                    type="sound"
                    theme="filled"
                />
                <a-icon
                    class="mt-3 mr-3"
                    v-if="documentType == 'mp4'"
                    style="fontSize:20px;color:red;"
                    type="play-circle"
                    theme="filled"
                />
                <a-icon
                    class="mt-3 mr-3"
                    v-if="documentType == 'txt'"
                    style="fontSize:20px;color:blue;"
                    type="file"
                    theme="filled"
                />
            </div>
            <div class="fab-card-width">
                <div class="fab-card-titulo-resp">
                    <strong>{{titleDefault}}</strong>
                    <div class="fab-card-width">
                        <small class="mt-2"><strong>Responsável:</strong> {{creators[0]}} </small>
                        <div class="fab-flex">
                            <small class="mt-2 mr-4" style="white-space: nowrap;display:flex;">
                                <strong class="mr-2">
                                    Início:
                                </strong>
                                <p v-if="hasEarliestDate">{{ earliestDate | date(true) }}</p>
                                <p v-if="!hasEarliestDate"> - </p>
                            </small>
                            <small class="mt-2 mr-4" style="white-space: nowrap;display:flex;">
                                <strong class="mr-2">
                                    Término:
                                </strong>
                                <p v-if="latestDate">{{ latestDate | date(true) }}</p>
                                <p v-if="!latestDate"> - </p>
                            </small>
                            <a>
                                <a-icon :theme="`${is_document_favorite ? 'filled' : 'outlined'}`" type="star" style="fontSize:20px;" @click="showModal" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fab-card-body">
            <div class="fab-card-body-section-1">
                <carousel
                    :images="imagesCollection"
                    v-if="showSlider"
                    @currentSlideIndex="changeImageIndex"
                    :start-image-at="startImageAt"
                    class="mt-6"
                />

                <!-- Videos -->
                <article v-if="hasVideos" class="mt-6 mx-auto text-center">
                    <h5 class="mb-2">Vídeos</h5>
                    <div v-for="(video, index) in videosCollection" :key="index">
                        <div
                            class="flex flex-col align-center items-center"
                            style="margin-top: -2.5rem;'"
                        >
                    
                            <dd-video-player :src="video" :start-at="startVideoAt"></dd-video-player>
                        
                            {{video.uri}}
                        </div>
                    </div>
                </article>

                <!-- Audios -->
                <article v-if="hasAudios" class="mt-6 mx-auto text-center">
                    <h5 class="mb-2">Áudios</h5>
                    <div class="flex flex-col align-center items-center">
                        <dd-audio-player
                            v-for="audio in audiosCollection"
                            :key="audio"
                            :src="audio"
                            :start-at="startAudioAt"
                        ></dd-audio-player>
                    </div>
                </article>
            </div>
            <div class="fab-card-body-section-2">

                <article v-if="hasImages" class="mt-6 mx-auto text-center">
                    <h5 class="mb-2">Transcrição do arquivo</h5>
                    <div
                        v-for="(image, index) in images"
                        :key="image.uri"
                        v-if="currentImageIndex == index"
                    > 
                    <p v-html="imageTranscription"></p>
                    </div>
                </article>

                <article v-if="hasVideos" class="mt-6 mx-auto text-center">
                    <div v-for="(video, index) in videos" :key="index">

                        <h5 class="mb-4 mt-10">Transcrição do vídeo</h5>
                        <div class="text-left">
                            <vue-markdown>
                            <p
                                class="mb-2"
                                v-html="videoTranscription"
                            ></p>
                            </vue-markdown>
                        </div>
                    </div>
                </article>

                <article v-if="hasAudios" class="mt-6 mx-auto text-center">

                    <h5 class="mb-4 mt-10">Transcrição do áudio</h5>
                    <div class="text-left">
                        <vue-markdown>
                            <p
                                class="mb-2"
                                v-html="audioTranscription"
                            >
                            </p>
                        </vue-markdown>
                    </div>
                </article>
            </div>
            <div class="fab-card-body-section-3">
                <section class="mt-4 w-full">
                    <h5 class="mb-2">Registrar comentário</h5>
                    <comments
                        :comments="comments"
                        @submit="createCommentHandler"
                        v-model="comment"
                        ref="comments"
                    ></comments>
                </section>
            </div>
        </div>

    </div>
        <vx-card v-else>
            <div class="container">
                <h4 class="text-red">{{ friendlyError }}</h4>
            </div>
        </vx-card>
    </div>

</template>

<script>
import carousel from "../../components/Carousel";
import comments from "../../components/Comments";
import DdVideoPlayer from "../../components/dd-video-player/DdVideoPlayer";
import DdAudioPlayer from "../../components/DdAudioPlayer";
import DdRequestNewPermission from "../../components/DdRequestNewPermission";
import { call, sync } from "vuex-pathify";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

export default {
    components: {
        carousel,
        comments,
        DdAudioPlayer,
        DdVideoPlayer,
        DdRequestNewPermission,
    },
    async created() {
        this.reset();

        try {
            this.$vs.loading();
            await this.fetchById(this.$route.params.id);

            this.$vs.loading.close();
            if (this.images.length > 0) {
                this.showSlider = true;
            }
        } catch (error) {
            this.$vs.loading.close();
            this.showError = true;

            this.$vs.notify({
                title: "Erro",
                text: this.friendlyError,
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circle",
            });
        }
        await this.addLastSeen();
    },
    async mounted() {
        await this.fetchFavoriteList();
        await this.isDocumentFavorite({id:this.$route.params.id});
        await this.getLevelsFoldersByDocument({id: this.$route.params.id});
    },
    data() {
        return {
            currentImageIndex: 0,
            comment: "",
            friendlyError:
                "Não foi possível carregar as informações do documento. Por favor, tente novamente mais tarde.",
            showError: false,
            showSlider: false,
            favoriteListId: "",
            documentType: "txt",
            showMoreLength: 10,
            showMoreMaxLength: 0,
            visible: false,
            modal_id_document: false,
            modal_name_document: '',
            modal_id_favorite: false,
        };
    },
    computed: {
        ...sync([
            "document/id",
            "document/titleDefault",
            "document/earliestDate",
            "document/latestDate",
            "document/creators",
            "document/level",
            "document/transcription",
            "document/images",
            "document/videos",
            "document/documents",
            "document/audios",
            "document/comments",
            "document/startAudioAt",
            "document/startImageAt",
            "document/startVideoAt",
            "document/highlight",
            "user/model.groupAlias",
            "favoriteList/favoriteListOption",
            "document/levels_id",
            "document/levels_name",
            "document/levels_fathers",
            "search/is_document_favorite",
            "search/favorite_list_ids",
        ]),
        hasFavoriteListOption() {
            return this.favoriteListOption.length > 0;
        },
        hasAudios() {
            return this.audios.length > 0;
        },
        hasEarliestDate() {
            return !isEmpty(this.earliestDate);
        },
        hasMoreToShow () {
            return this.showMoreLength < this.showMoreMaxLength;
        },
        hasImages() {
            return this.images.length > 0;
        },
        hasImagesTranscription() {
            return this.imagesTranscription.length > 0;
        },
        hasVideos() {
            return this.videos.length > 0;
        },
        videosCollection() {
            return this.videos.map((video) => process.env.VUE_APP_URL_API + video.uri);
        },
        audiosCollection() {
            return this.audios.map((audio) => process.env.VUE_APP_URL_API + audio.uri);
        },
        imagesCollection() {
            return this.images.map((image) => process.env.VUE_APP_URL_API + image.uri);
        },
        imageTranscription() {
            if(this.images.length > 0) {
                return this.images[this.currentImageIndex].transcription.replace(/(?:\r\n|\r|\n)/g, "<br />"); 
            }
            return "";
        },
        videoTranscription() {
            if(this.videos.length > 0) {
                return this.videos[0].transcription.replace(/(?:\r\n|\r|\n)/g, "<br />"); 
            }
            return "";
        },
        audioTranscription() {
            if(this.audios.length > 0) {
                return this.audios[0].transcription.replace(/(?:\r\n|\r|\n)/g, "<br />"); 
            }
            return "";

        },
        isAdmin() {
            return this.groupAlias === "administrator";
        }
    },
    methods: {
        ...call({
            getLevelsFoldersByDocument: "document/getLevelsFoldersByDocument",
            reset: "document/reset",
            fetchById: "document/fetchById",
            createComment: "document/createComment",
            fetchFavoriteList: "favoriteList/fetchFavoriteList",
            setSeenLast: "search/setSeenLast",
            isDocumentFavorite: "search/isDocumentFavorite",
            getFavoritesUserIdList: "search/getFavoritesUserIdList",
            addDocumentFavoriteList:
                "documentsFavoriteLists/addDocumentFavoriteList",
        }),
        changeImageIndex(index) {
            this.currentImageIndex = index;
        },
        checkFavoriteExists(id){
            return this.favorite_list_ids.includes(parseInt(id));
        },
        showModal() {
            this.visible = true;
            this.modal_id_document = this.$route.params.id;
            this.modal_name_document = this.titleDefault;
            this.selectedDocuments = this.$route.params.id;


            this.getFavoritesUserIdList({id: this.$route.params.id});
        },
        handleOk() {
            this.addDocument();
            this.visible = false;
            this.modal_id_document = false;
            this.modal_name_document = '';
        },
        selectFavoriteId(id) {
            this.modal_id_favorite = id;
            this.favoriteListId = id;
        },
        async addLastSeen() {
            if (this.videos.length > 0) {
                this.documentType = 'mp4';
            } else if (this.audios.length > 0) {
                this.documentType = 'mp3';
            } else if (this.images.length > 0 || this.transcription > 0) {
                this.documentType = 'txt';
            }

            await this.setSeenLast({
                item_id: this.$route.params.id,
                shared_with: this.groupAlias,
                folder: this.level,
                name: this.titleDefault || 'Sem título',
                type: this.documentType
            });
        },
        async showMore () {
            this.showMoreLength += 10;
        },
        async createCommentHandler() {
            if (isEmpty(this.comment)) {
                this.$vs.notify({
                    title: "Erro",
                    text: "Por favor, insira seu comentário antes de salvar",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
                return;
            }

            this.$vs.loading();

            try {
                await this.createComment({
                    documentId: this.$route.params.id,
                    comment: this.comment,
                });
                this.$refs.comments.reset();
                this.$vs.loading.close();
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text: error.message,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
            }
        },
        async addDocument() {
            this.$vs.loading();
            try {
                await this.addDocumentFavoriteList({
                    favoriteListId: this.favoriteListId,
                    documentsIds: this.$route.params.id,
                });

                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Documento Adicionado!",
                    text:
                        "Documento adicionado a lista de favoritos com sucesso!",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });

                this.favoriteListId = "";
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro!",
                    text: error.message,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
            }
        this.modal_id_favorite = false;
        },
        encodeUrl(url) {
            return encodeURIComponent(url);
        }
    },
};
</script>

<style lang="scss" scoped>
article {
    max-width: 770px;
}
.btn-favorite {
    margin: 10px auto;
}

.favorite-container {
    display: flex;
    justify-content: flex-end;

    > div {
        display: inline-flex;
        align-items: flex-end;
    }

    button {
        margin-left: 16px;
    }

}
    .fab-card-titulo {
        background-color: #ebecf0;
        padding: 15px;
        display: flex;
        border: 1px solid rgb(204, 202, 202);
        border-radius: 2px;

    }
    .fab-card-titulo-resp {
        display: flex;
        flex-direction: column;
        width:100%!important;
    }
    .fab-card-titulo-flex {
        display: flex;
    }
    .fab-card-width {
        width:100%!important;
        display: flex;
        justify-content: space-between;
    }
    .fab-flex {
        display: flex;
    }
    .fab-card-body {
        border: 1px solid rgb(204, 202, 202);
    }
    .fab-card-body-section-1 {
        padding-bottom: 15px;
        border: 1px solid rgb(204, 202, 202);
    }
    .fab-card-body-section-2 {
        border: 1px solid rgb(204, 202, 202);
        padding-bottom: 15px;
    }
    .fab-card-body-section-3 {
        margin: 50px;
        padding-bottom: 15px;
    }
    .bg-gray {
        background-color: rgb(204, 202, 202);
    }
</style>
